import React from 'react';
import { Dropdown } from '@/components/shared/Dropdown';
import classNames from 'classnames';

import { SortValue } from '../types';
import * as styles from './Style.module.scss';

type Props = {
  current: SortValue;
  sortValues: SortValue[];
  onChange: (orderBy: SortValue['value']) => void;
};

export const Sorter: React.FC<Props> = ({ current, sortValues, onChange }) => (
  <Dropdown
    dataTest="order-by-dropdown"
    text={current.label}
    buttonClassNames={styles.toggleButton}
    menuWrapperClassNames={styles.menuWrapper}
    menuNode={sortValues.map((sortValue) => (
      <div
        key={sortValue.value}
        data-test={`order-by-value[${sortValue.value}]`}
        className={classNames(
          styles.menuItem,
          current.value === sortValue.value ? 'active' : '',
        )}
        onClick={() => onChange(sortValue.value)}
      >
        {sortValue.label}
      </div>
    ))}
  />
);
